/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { getFullQuote, fetchLocations, fetchOccupancies } from '../../../actions'

/**
 * Import
 * - Page component
 */
import EditQuote from '../../../components/pages/Quote/EditQuote/EditQuote'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
        riskLocations: state.quote.riskLocations,
        isCollectors: get(state, 'quote.full.response.quote.isCollectors', false),
        isMuseums: get(state, 'quote.full.response.quote.isMuseums', false),
        isDealersStock: get(state, 'quote.full.response.quote.isDealersStock', false),
        isWineSpirits: get(state, 'quote.full.response.quote.isWineSpirits', false),
        isWineSpiritsSteve: get(state, 'quote.full.response.quote.isWineSpiritsSteve', false),
        isCommercialProperty: get(state, 'quote.full.response.quote.isCommercialProperty', false),
        occupancies: get(state, 'step00.occupancies.data', []),
    }
}

export default connect(
    mapStateToProps,
    {
        quote: 'The QUOTE! EditQuote',
        getFullQuote: getFullQuote,
        fetchLocations,
        fetchOccupancies,
    }
)(EditQuote)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/EditQuote.tsx